import { ArrowRight, RadioTower } from "lucide-react";
import { useSiteBranding } from "@/context/SiteContext";

export const RealTimeAssetIntelligenceStrip = () => {
  const { getWhatsAppHref } = useSiteBranding();

  return (
  <section className="section-shell pt-2" data-testid="real-time-asset-intelligence-strip-shell">
    <div className="flex flex-col gap-4 rounded-[28px] border border-[#D7C39A]/28 bg-[#0C285A] px-6 py-5 text-white shadow-[0_24px_70px_rgba(0,25,53,0.22)] lg:flex-row lg:items-center lg:justify-between" data-testid="real-time-asset-intelligence-strip">
      <div className="flex items-start gap-4">
        <div className="rounded-full border border-[#D4AF37]/28 bg-[#fff4dc]/10 p-3 text-[#F5D98C]">
          <RadioTower className="h-5 w-5" />
        </div>
        <div>
          <p className="!text-[#F5D98C] text-xs font-bold uppercase tracking-[0.22em]">Real-Time Asset Intelligence</p>
          <p className="mt-2 max-w-3xl !text-white text-sm leading-7">Unlock a live 60-second valuation angle and route the conversation directly into Signature Intelligence.</p>
        </div>
      </div>
      <a
        className="gold-button !justify-center"
        data-testid="real-time-asset-intelligence-whatsapp-cta"
        href={getWhatsAppHref("Hello SG Prop Portal, I want my 60-Second Valuation Briefing.")}
        rel="noreferrer"
        target="_blank"
      >
        Get My 60-Second Valuation Briefing <ArrowRight className="ml-2 h-4 w-4" />
      </a>
    </div>
  </section>
  );
};